import { PermissionId } from 'utils/powerLevelsConfig';

/*
 * Static config map for Type B "?" info tooltips on `PermissionCheckbox`.
 *
 * VALUES ARE I18N KEYS, not English strings. `PermissionCheckbox` calls `t(value)`
 * when rendering the tooltip (see spec/tech.md §9 Decision 19).
 *
 * The map ships empty (`{}`) — no "?" icons render until OD-02 is resolved.
 * Adding the first entry is a 1-line change here plus one i18n key per locale
 * file in `apps/meedio-connect/public/locales/`.
 *
 * Six candidate keys proposed in spec/tech.md §3.4 (OD-02 — PENDING USER):
 *   PermissionId.WorkspaceManageRoles         -> 'workspace_roles.permission.workspace_manage_roles.description'
 *   PermissionId.MeetingManageBreakoutRooms   -> 'workspace_roles.permission.meeting_manage_breakout_rooms.description'
 *   PermissionId.ChatDeleteOthersMessages     -> 'workspace_roles.permission.chat_delete_others_messages.description'
 *   PermissionId.ChatReassignManager          -> 'workspace_roles.permission.chat_reassign_manager.description'
 *   PermissionId.MeetingReassignManager       -> 'workspace_roles.permission.meeting_reassign_manager.description'
 *   PermissionId.WorkspaceCreateSubWorkspace  -> 'workspace_roles.permission.workspace_create_sub_workspace.description'
 *   PermissionId.WorkspaceDelete              -> 'workspace_roles.permission.workspace_delete.description'
 */
export const permissionDescriptions: Partial<Record<PermissionId, string>> = {
  [PermissionId.WorkspaceInviteMembers]: 'workspace_roles.permission.workspace_invite_members.description',
  [PermissionId.WorkspaceManageRoles]: 'workspace_roles.permission.workspace_manage_roles.description',
};
